import React from "react";

import markerRed from '../../../images/marker-red.svg'
import markerGreen from '../../../images/marker-green.svg'
import markerOrange from '../../../images/marker-orange.svg'
import markerGray from '../../../images/marker-gray.svg'

/*global google*/
/*global MarkerClusterer*/

let map = null;

class OnMap extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            orders: []
        }
    }

    componentWillMount() {
        this.setState({
            orders: this.props.orders
        })
    }

    componentDidMount() {
        this.initEditor("did");
    }

    componentWillReceiveProps(nextProps) {
        let prOrders = this.props.orders;
        let nxOrders = nextProps.orders;

        if((
            prOrders.isFetching !== nxOrders.isFetching && !nxOrders.isFetching) ||
            prOrders.isFetchingMore !== nxOrders.isFetchingMore && !nxOrders.isFetchingMore
        )
        {
            this.setState({
                orders: nextProps.orders
            }, () => this.initEditor("receive"))
        }
    }

    getMarkerColor(status) {
        switch(status){
            case 1:
            case 2:
            case 9:
            return markerGreen
            case 4:
            return markerOrange
            case 3:
            return markerRed
            default:
            return markerGray
        }
    }

    initEditor(opt) {
        const { results } = this.state.orders.data;
        let resLength = results.length;

        map = new google.maps.Map(this.refs.map, {
            center: {lat: 0, lng: 0},
            zoom: 1,
            scrollwheel: true,
        });
        var bounds = new google.maps.LatLngBounds();
        var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var markers = [];

        results.map((location, i) => {
            let lat = location.address_latitude, 
                lng = location.address_longitude;
            const threshold = (Math.random()*0.5 + 0.5) / 1000;
            const choise = Math.random() < 0.5;
            const exactCoords = results.filter((item,index) => {
                return (item.address_latitude === lat
                    && item.address_longitude === lng) 
                    && index < i;
            })
            if(exactCoords.length) {
                choise ? lat += threshold : lng += threshold;
            }

            let pin = new google.maps.LatLng(
                lat,
                lng
            );

            var contentString = '<div id="map-window">'+
                '<div id="siteNotice">'+
                '</div>'+
                '<h1 class="firstHeading">'+location.title+'</h1>'+
                '<div id="bodyContent">'+
                '<p><a class="window-link" href="'+window.siteUrl+'/orders/execute/'+location.id+'">'+
                'подробное описание заказа</a> '+
                '</p>'+
                '</div>'+
                '</div>';

            var locationInfowindow = new google.maps.InfoWindow({
                content: contentString
            });

            var marker = new google.maps.Marker({
                position: pin,
                map: map,
                icon: this.getMarkerColor(location.status),
                infowindow: locationInfowindow
            });

            markers.push(marker);
            bounds.extend(marker.getPosition());

            new google.maps.event.addListener(marker, 'click', function() {
                markers.forEach(function(marker) {
                    marker.infowindow.close(map, marker);
                });

                this.infowindow.open(map, this);
            });
        });    

        setTimeout(() => {
            new MarkerClusterer(map, markers,
                {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
            );
        }, 10)

        if(resLength == 1) {    
            map.setZoom(5);
            map.setCenter({
                lat: results[0].address_latitude,
                lng: results[0].address_longitude
            })
        }
      
        if(resLength > 1){
            map.fitBounds(bounds);
        }
    }

    render(){
        return (
            <div className="tab-content tab-content2 map-content">
                <div ref="map" id="map" className="map" style={{height: "400px"}}></div>
            
                <ul className="map-explanations">
                    <li className="map-explanation green">Поиск исполнителя</li>
                    <li className="map-explanation red">Ждут приемки</li>
                    <li className="map-explanation orange">Ждут исполнения</li>
                    <li className="map-explanation gray">Закрытые</li>
                </ul>
            </div>
        )
    }
}

export default OnMap;


// WEBPACK FOOTER //
// ./src/components/Orders/SubComponentsRightContent/OnMap.js